module.exports = __webpack_public_path__ + "img/close_door.0ec75fee.svg";